"use client";
import { useContext, useState } from "react";
import { QueryRequestContext } from "../../data/index";
import { CoworldReplayRuntime } from "./coworld-replay-runtime";
import { CoworldReplayPaused } from "./coworld-replay-paused";
import { useReplayFrameControls } from "./use-replay-frame-controls";
import type { CoworldReplayFrameProps } from "./replay-frame.types";
import { useReplaySession } from "./session/use-replay-session";
import { useReplayTiming } from "./playback/use-replay-timing";

export function CoworldReplayFrame(props: CoworldReplayFrameProps) {
  const { elevatedPrivileges } = useContext(QueryRequestContext);
  const controls = useReplayFrameControls(props);

  if (!controls.playing)
    return (
      <CoworldReplayPaused
        {...props}
        gate={controls.gate}
        onPlay={controls.play}
      />
    );

  const commandKey = JSON.stringify([
    props.coworldId,
    props.replayUri,
    elevatedPrivileges,
    props.chrome ?? "full",
    controls.attempt,
    props.surface,
    props.telemetryContext.episodeId,
    props.telemetryContext.game,
    props.telemetryContext.gameVersion,
  ]);
  return (
    <ReplaySessionFrame
      key={commandKey}
      {...props}
      onStateChange={controls.reportState}
      onRetry={controls.retry}
      onPause={controls.pause}
    />
  );
}

function ReplaySessionFrame(
  props: CoworldReplayFrameProps & { onRetry: () => void; onPause: () => void },
) {
  const telemetry = useReplayTiming(props);
  const [sessionError, setError] = useState<string | null>(null);
  const session = useReplaySession({ ...props, telemetry, setError });
  return (
    <CoworldReplayRuntime
      {...props}
      {...session}
      sessionError={sessionError}
      telemetry={telemetry}
    />
  );
}
